import { Link } from 'react-router-dom';
import { Text } from './ui/typography';

const footerLinks = [
  { to: '/', label: 'O meni' },
  { to: '/psychotherapy', label: 'Psihoterapija' },
  { to: '/psychology', label: 'Psihološko svetovanje' },
  { to: '/fields', label: 'Področja dela' },
  { to: '/pricelist', label: 'Cenik' },
  { to: '/contact', label: 'Kontakt' },
];

function Footer() {
  return (
    <div className='border-t-[1px] flex flex-col border-secondaryBg w-full lg:pb-24 pb-12'>
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 pt-12 px-6 max-w-3xl m-auto" aria-label="Noge strani">
          {footerLinks.map((link) => (
            <Link key={link.to} to={link.to} className="font-inter text-base text-baseColor hover:underline">
              {link.label}
            </Link>
          ))}
        </nav>
        <Text className="text-base lg:pt-16 pt-8 w-auto m-auto text-center">© {new Date().getFullYear()} Špela Verbnik · Celovška cesta 73, 1000 Ljubljana</Text>
    </div>
  )}

export default Footer;
